import EntitiesPage from "@/app/entities/pages/EntitiesPage.vue";
import EntitiesTemplate from "@/app/entities/components/templates/EntitiesTemplate.vue";
import CampaignsTemplate from "@/app/entities/components/templates/CampaignsTemplate.vue";
import TypificationsTemplate from "@/app/entities/components/templates/TypificationsTemplate.vue";
import BasesTemplate from "@/app/entities/components/templates/BasesTemplate.vue";
import StrategiesPage from "@/app/strategies/pages/StrategiesPage.vue";
import StrategiesFilterPage from "@/app/strategies/pages/StrategiesFilterPage.vue";
import StrategiesTemplatePage from "@/app/strategies/pages/StrategiesTemplatePage.vue";
import QueuesPage from "@/app/queues/pages/QueuesPage.vue";

export default [
  {
    path: "/operations",
    name: "operations",
    component: EntitiesPage,
    redirect: "/operations/board",
    children: [
      {
        path: "board",
        component: EntitiesTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "campaigns",
        component: CampaignsTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "campaigns/:id",
        component: TypificationsTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "bases",
        component: BasesTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "strategies",
        component: StrategiesPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "strategies/filter",
        component: StrategiesFilterPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "strategies/template",
        component: StrategiesTemplatePage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "queues",
        component: QueuesPage,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "forms",
        redirect: "/flows/forms",
        // component: FormsTemplate,
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "forms/:id",
        redirect: (to) => ({ path: `/flows/forms/${to.params.id}` }),
        // component: CreateFormTemplate,
        // meta: {
        //   requiresAuth: true,
        // },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];
